import { Pipe, PipeTransform } from '@angular/core';
import {PermissaoEnum, RoleEnum} from "../../../models/role.enum";

@Pipe({
  name: 'roleName',
  standalone: true
})
export class RoleNamePipe implements PipeTransform {

  transform(value: number): string {
    const role = Object.entries(PermissaoEnum).find(([_, v]) => v === value);
    return role ? role[0].replace('ROLE_', '') : 'Desconhecido';
  }

}
